import { createSlice } from "@reduxjs/toolkit";
import {
  getTempWarehousesDeposit,
  addNewTempWarehouseDeposit,
  updateTempWarehouseDeposit,
  deleteTempWarehouseDeposit,
  getTempWarehousesWithdraw,
  addNewTempWarehouseWithdraw,
  updateTempWarehouseWithdraw,
  deleteTempWarehouseWithdraw,
  getTempWarehousesSummary,
  addNewTempWarehouseSummary,
} from "./thunk";

export const initialState = {
  // Deposit
  tempWarehousesDeposit: [],
  isLoadingDeposit: false,
  isDepositSuccess: false,
  errorDeposit: null,

  // Withdraw
  tempWarehousesWithdraw: [],
  isLoadingWithdraw: false,
  isWithdrawSuccess: false,
  errorWithdraw: null,

  // Summary
  tempWarehousesSummary: [],
  isLoadingSummary: false,
  isSummarySuccess: false,
  errorSummary: null,
};

const tempWarehouseSlice = createSlice({
  name: "tempWarehouse",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // ===========================[ Deposit ]===========================
    builder.addCase(getTempWarehousesDeposit.pending, (state) => {
      state.isLoadingDeposit = true;
      state.isDepositSuccess = false;
      state.errorDeposit = null;
    });
    builder.addCase(getTempWarehousesDeposit.fulfilled, (state, action) => {
      state.isLoadingDeposit = false;
      state.isDepositSuccess = true;
      state.tempWarehousesDeposit = Array.isArray(action.payload)
        ? action.payload
        : action.payload ?? [];
    });
    builder.addCase(getTempWarehousesDeposit.rejected, (state, action) => {
      state.isLoadingDeposit = false;
      state.isDepositSuccess = false;
      state.errorDeposit = action.error.message;
    });

    builder.addCase(addNewTempWarehouseDeposit.fulfilled, (state, action) => {
      if (action.payload) {
        state.tempWarehousesDeposit = [action.payload, ...state.tempWarehousesDeposit];
      }
    });

    builder.addCase(updateTempWarehouseDeposit.fulfilled, (state, action) => {
      if (!action.payload?._id) return;
      state.tempWarehousesDeposit = state.tempWarehousesDeposit.map((item) =>
        item._id?.toString() === action.payload._id?.toString()
          ? { ...item, ...action.payload }
          : item
      );
    });

    builder.addCase(deleteTempWarehouseDeposit.fulfilled, (state, action) => {
      state.tempWarehousesDeposit = state.tempWarehousesDeposit.filter(
        (item) => item._id?.toString() !== action.payload.id?.toString()
      );
    });

    // ===========================[ Withdraw ]===========================
    builder.addCase(getTempWarehousesWithdraw.pending, (state) => {
      state.isLoadingWithdraw = true;
      state.isWithdrawSuccess = false;
      state.errorWithdraw = null;
    });
    builder.addCase(getTempWarehousesWithdraw.fulfilled, (state, action) => {
      state.isLoadingWithdraw = false;
      state.isWithdrawSuccess = true;
      state.tempWarehousesWithdraw = Array.isArray(action.payload)
        ? action.payload
        : action.payload ?? [];
    });
    builder.addCase(getTempWarehousesWithdraw.rejected, (state, action) => {
      state.isLoadingWithdraw = false;
      state.isWithdrawSuccess = false;
      state.errorWithdraw = action.error.message;
    });

    builder.addCase(addNewTempWarehouseWithdraw.fulfilled, (state, action) => {
      if (action.payload) {
        state.tempWarehousesWithdraw = [action.payload, ...state.tempWarehousesWithdraw];
      }
    });

    builder.addCase(updateTempWarehouseWithdraw.fulfilled, (state, action) => {
      if (!action.payload?._id) return;
      state.tempWarehousesWithdraw = state.tempWarehousesWithdraw.map((item) =>
        item._id?.toString() === action.payload._id?.toString()
          ? { ...item, ...action.payload }
          : item
      );
    });

    builder.addCase(deleteTempWarehouseWithdraw.fulfilled, (state, action) => {
      state.tempWarehousesWithdraw = state.tempWarehousesWithdraw.filter(
        (item) => item._id?.toString() !== action.payload.id?.toString()
      );
    });

    // ===========================[ Summary ]===========================
    builder.addCase(getTempWarehousesSummary.pending, (state) => {
      state.isLoadingSummary = true;
      state.isSummarySuccess = false;
      state.errorSummary = null;
    });
    builder.addCase(getTempWarehousesSummary.fulfilled, (state, action) => {
      state.isLoadingSummary = false;
      state.isSummarySuccess = true;
      state.tempWarehousesSummary = Array.isArray(action.payload)
        ? action.payload
        : action.payload ?? [];
    });
    builder.addCase(getTempWarehousesSummary.rejected, (state, action) => {
      state.isLoadingSummary = false;
      state.isSummarySuccess = false;
      state.errorSummary = action.error.message;
    });

    builder.addCase(addNewTempWarehouseSummary.fulfilled, (state, action) => {
      if (action.payload) {
        state.tempWarehousesSummary = [action.payload, ...state.tempWarehousesSummary];
      }
    });
  },
});

export default tempWarehouseSlice.reducer;
